const DOCUMENT_LINK_ATTR = 'data-hs-document-link';
const TOKEN_TAG_ATTR = 'token-tag';
const DISPLAY_TEXT_ATTR = 'display-text';

// The description is saved to an HTML CRM property, whose sanitizer keeps
// data-* attributes but drops the rest. This helper restores the `token-tag` and
// optional `display-text` attributes based on the saved html so the link still renders
// as expected when making further edits.
export function restoreDocumentLinkAttributes(html) {
  if (!html.includes(DOCUMENT_LINK_ATTR)) {
    return html;
  }
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  for (const el of parsed.querySelectorAll(`[${DOCUMENT_LINK_ATTR}]`)) {
    const anchor = el.querySelector('a');
    const href = anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute('href');
    if (!anchor || !href) {
      continue;
    }
    if (!el.getAttribute(TOKEN_TAG_ATTR)) {
      el.setAttribute(TOKEN_TAG_ATTR, href);
    }
    if (!el.getAttribute(DISPLAY_TEXT_ATTR)) {
      var _anchor$textContent;
      el.setAttribute(DISPLAY_TEXT_ATTR, (_anchor$textContent = anchor.textContent) !== null && _anchor$textContent !== void 0 ? _anchor$textContent : '');
    }
  }
  return parsed.body.innerHTML;
}